import React from 'react'

import LeftArrow from '../../icons/left-arrow.svg?react'
import { PSButton, PSButtonPrimary } from '../app/PSButton'

type Props = {
    onCreateNewField: () => void
    onBack: () => void
}

export const FieldsEmptyState = ({ onCreateNewField, onBack }: Props) => {
    return (
        <div className="servicesSettings">
            <div className="header">
                <PSButton style={{ marginLeft: 0, marginRight: 16 }} onClick={onBack}>
                    <LeftArrow />
                </PSButton>
                <h1>List of questions</h1>
            </div>
            <div className="empty">
                <div>You don't have any questions added yet</div>
                <div className="promo">Add questions for clients to fill out 📝</div>
                <PSButtonPrimary style={{ height: '40px' }} onClick={() => onCreateNewField()}>
                    Add a question
                </PSButtonPrimary>
            </div>
        </div>
    )
}
